import React from 'react'
import { render } from 'react-dom'
import browserHistory from '../common/history'
import { syncHistoryWithStore, routerReducer } from 'react-router-redux'
import App from './App'
import configureStore from '../store/configureStore'

global.jQuery = require('jquery')
require('bootstrap')

const store = configureStore({ routerReducer })
const history = syncHistoryWithStore(browserHistory, store)

const app = <App store={store} history={history} />

render(app, document.getElementById('root'))
